import Google from "../shared/googleapi.js"
import braille from "../shared/braille.js"
import GoogleCalendar from "./calendar-data.js"
import Menu from "../shared/menu.js"
import FuzzyClock from "../fuzzy/fuzzy.js"
import StatusBar from "../shared/statusbar.js"
import m from "mithril"
import moment from "moment"
import "./agenda.css"

var reloadTimeout = null;
var AgendaRootContainer = {
  oninit: function() {
    Google.load(function() {
      Google.clientInit().then(function() {
        if (Google.isSignedIn()) { GoogleCalendar.fetchIfNeeded(); }
        gapi.auth2.getAuthInstance().isSignedIn.listen(function(isSignedIn) {
          if (!isSignedIn) { GoogleCalendar.clearData(); }
        });
      });
    });
  },
  onremove: function() {
    clearTimeout(reloadTimeout)
  },
  view: function(vnode) {

    var attrs = vnode.attrs || {};
    var isWidget = attrs.class == "widget"
    var calData = GoogleCalendar.getData();
    if (!calData) {
      if (!reloadTimeout) reloadTimeout = setTimeout(function(){ location.reload() }, 60000);
      if (!Google.isReady()) {
        return m('div', {class:'status', onclick: function() {location.reload()}}, 'Loading Google...')
      } else if (!Google.isSignedIn()) {
        if (isWidget) return ""
        return Google.signInContent();  
      } 
    }

    if (reloadTimeout) {
      clearTimeout(reloadTimeout);
      reloadTimeout = null;
    }

    var menu = {items: [
      { title:"Refresh", onclick: function() { GoogleCalendar.fetch(); } }, 
      { title:"Reload Page", onclick: function() { location.clearAndReload(); } }, 
      { title:"Redraw Page", onclick: function() { document.redraw(true); } }, 
      { title:"Sign out", onclick: function() { Google.signOut(); }}
    ]};

    
    var components = []

    if (!isWidget) {
      components = [
        m(StatusBar),
        this.standalone ? m(Menu, menu) : undefined,
        m(FuzzyClock, {class:"widget", onclick:function(){GoogleCalendar.fetch()}})
      ];
    }
    components.push(m(AgendaContainer, {class:attrs.class}));
    return components;
  }
}

var AgendaContainer = {
  view: function(vnode) {
    var attrs = vnode.attrs;
    var isWidget = attrs.class == "widget"
    
    var calendars = GoogleCalendar.getData();

    if (!calendars) return "No Events"

    if (calendars.expired) {
      console.info("Calendar: Using old data, requesting update")
      // GoogleCalendar.fetch();      
    }

    var eventNodes = [];

    var now = moment();
    var endOfDay = moment().endOf('day');

    if (isWidget) {
      eventNodes.push(m(CalEventCluster, {title:"Agenda"}));
    }

    var eventCount = 0;
    calendars.forEach(function(calendar) {
      var events = calendar.items
      if (!events) return;
      var lastDate = undefined
      var wroteTomorrow  = false
      events.forEach(function(event) {
        var startDate = moment(event.start.dateTime  || event.start.date)
        var endDate = moment(event.end.dateTime  || event.end.date)
        if (!startDate.isValid()) return;
        if (startDate < now) return;
        eventCount++;
        if (isWidget && eventCount > 2) return;

        // if (date < moment()) return;
        if (startDate > endOfDay && !wroteTomorrow) {
          eventNodes.push(m(CalEventCluster, {title:"tomorrow"}));
          wroteTomorrow = true;
        }
        eventNodes.push(m(CalEvent, {info:event}));
      });
    });

    return m("div#agenda-container", {class: isWidget ? "widget" : undefined},[
      eventNodes]
    )
  }
}

var CalEventCluster = {
  view: function(vnode) {
   return m("div.event-cluster", {class:"h3"}, vnode.attrs.title.toUpperCase())
  }
}

var CalEvent = {
  view: function(vnode) {
    var attrs = vnode.attrs;
    var info = vnode.attrs.info;
    var classList = []
    // console.info(info, info.start.datetime)
    var allday = info.start.date != undefined
    var date = moment(info.start.dateTime || info.start.date)

    if (allday) classList.push("allday")
    var timeString = allday ? "" : date.format("h:mm a").replace(" am", "a").replace(" pm", "p")
    var title = info.summary;
    var isPrivate = info.visibility == "private";
    if (isPrivate) title = braille(title)
    return m("div.event", {class:classList.join(" ")},
      m("span.event-time", timeString), (" "),
      m("span.event-title", {onclick:function(e){e.target.innerText = info.summary}},title), 
      m("div.event-location", info.location)
      )
  }
}


module.exports = AgendaRootContainer